<template>
    <p class="mb-0">
        <span :class="['main-text', 'small-main-text']">
            {{ formatPercentage(offer.apr_display.formatted) }}
        </span>

        <span class="small-text d-flex align-self-start" v-if="offer.apr_prefix == 'Confirmed'">
            <span class="d-none d-lg-flex">{{ $t('results.guaranteedAprDesktop') }}</span>
            <span class="d-lg-none">{{ $t('results.guaranteedAprMobile') }}</span>
            <i class="icon-question-mark d-flex" v-if="tooltipOptions.content" v-tippy="tooltipOptions"></i>
        </span>

        <span class="small-text d-flex align-self-start" v-else-if="offer.apr_prefix == 'Aprc'">
            {{ $t('results.aprc')
            }}<i class="icon-question-mark d-flex" v-if="tooltipOptions.content" v-tippy="tooltipOptions"></i>
        </span>

        <span class="small-text d-flex align-self-start" v-else>
            {{ $t('results.repApr') }}
            <span v-if="offer.type === 'credit card only'">&nbsp;({{ $t('results.offerBlocks.variable') }})</span>
            <i class="icon-question-mark d-flex" v-if="tooltipOptions.content" v-tippy="tooltipOptions"></i>
        </span>
    </p>
</template>

<script>
import { formatPercentage } from '@js/utilities/number.js'

export default {
    data() {
        return {
            tooltipOptions: {
                content: null,
                trigger: 'click',
                arrow: true,
            },
        }
    },
    inject: ['offerGroup', 'offer'],
    created() {
        this.tooltipOptions.content = this.toolTip()
    },
    computed: {
        offerGroupType: function () {
            return this.offerGroup
        },
        territory: function () {
            return process.env.TERRITORY
        },
    },
    methods: {
        formatPercentage: formatPercentage,
        toolTip: function () {
            if (
                (this.offer.apr_prefix === 'Confirmed' && this.offer.likelihood === 100) ||
                (this.offer.apr_prefix === 'Confirmed' && this.offerGroupType === 'prequal_same_loan_amount') ||
                (this.offer.apr_prefix === 'Confirmed' && this.offerGroupType === 'prequal_different_loan_amount')
            ) {
                return this.$t('results.offerBlocks.toolTipText.aprConfirmed')
            }

            if (
                (this.offer.apr_prefix === 'Rep' && this.offer.likelihood === 100) ||
                (this.offer.apr_prefix === 'Rep' && this.offerGroupType === 'prequal_same_loan_amount') ||
                (this.offer.apr_prefix === 'Rep' && this.offerGroupType === 'prequal_different_loan_amount')
            ) {
                return this.$t('results.offerBlocks.toolTipText.representativeApr')
            }

            if (
                (this.offer.apr_prefix === 'Confirmed' && this.offer.likelihood < 100) ||
                (this.offer.apr_prefix === 'Confirmed' && this.offerGroupType === 'non_prequal') ||
                (this.offer.apr_prefix === 'Confirmed' && this.offerGroupType === 'eligible')
            ) {
                return this.$t('results.offerBlocks.toolTipText.aprConfirmed')
            }

            if (
                (this.offer.apr_prefix === 'Rep' && this.offer.likelihood < 100) ||
                (this.offer.apr_prefix === 'Rep' && this.offerGroupType === 'non_prequal') ||
                (this.offer.apr_prefix === 'Rep' && this.offerGroupType === 'eligible')
            ) {
                return this.$t('results.offerBlocks.toolTipText.representativeApr')
            }

            if (this.offer.apr_prefix === 'Aprc') {
                return this.$t('results.offerBlocks.aprToolTips.aprc')
            }

            return null
        },
    },
}
</script>
